import { render } from "./LoanCalculator.vue?vue&type=template&id=6c9cfa73"
import script from "./LoanCalculator.vue?vue&type=script&lang=js"
export * from "./LoanCalculator.vue?vue&type=script&lang=js"
script.render = render

export default script